(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["add-to-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.mrSizeSelectionGuardLoaded) return;

    window.mrSizeSelectionGuardLoaded = true;

    const normalize = (value) => {
      return String(value || '')
        .trim()
        .toLowerCase();
    };

    const setButtonText = (button, text) => {
      if (!button) return;

      /*
       * Support custom / future button markup if the text
       * is wrapped in a dedicated element.
       */
      const explicitTextElement =
        button.querySelector(
          '[data-add-to-cart-text], .add-to-cart-text'
        );

      if (explicitTextElement) {
        explicitTextElement.textContent = text;
        return;
      }

      /*
       * Horizon currently outputs the button label as a
       * direct text node. Change only that node so that
       * the success/checkmark markup remains untouched.
       */
      const textNode = Array.from(button.childNodes).find(
        (node) =>
          node.nodeType === Node.TEXT_NODE &&
          node.textContent.trim() !== ''
      );

      if (textNode) {
        textNode.textContent = ` ${text} `;
        return;
      }

      /*
       * Fallback if the structure changes.
       */
      const addedElement =
        button.querySelector('.add-to-cart__added');

      button.insertBefore(
        document.createTextNode(` ${text} `),
        addedElement || null
      );
    };

    const initializeGuard = (guard) => {
      if (!(guard instanceof HTMLElement)) return;

      if (
        guard.dataset.mrRequireSizeSelection !== 'true'
      ) {
        return;
      }

      if (
        guard.dataset.mrSizeGuardInitialized === 'true'
      ) {
        return;
      }

      const productId = String(
        guard.dataset.mrProductId || ''
      );

      const sizeOptionName =
        guard.dataset.mrSizeOptionName || '';

      if (!productId || !sizeOptionName) return;

      const section =
        guard.closest('.shopify-section') ||
        document;

      const productForm =
        guard.closest('product-form-component');

      if (!productForm) return;

      const variantPickers = Array.from(
        section.querySelectorAll('variant-picker')
      );

      const variantPicker = variantPickers.find(
        (picker) =>
          String(picker.dataset.productId) === productId
      );

      if (!variantPicker) return;

      const normalizedSizeName =
        normalize(sizeOptionName);

      /*
       * Button / radio variant picker
       */
      const sizeRadios = Array.from(
        variantPicker.querySelectorAll(
          'input[type="radio"]'
        )
      ).filter((input) => {
        const inputName = normalize(
          input.getAttribute('name')
        );

        return (
          inputName === normalizedSizeName ||
          inputName.startsWith(
            `${normalizedSizeName}-`
          )
        );
      });

      /*
       * Dropdown variant picker
       */
      const sizeSelects = Array.from(
        variantPicker.querySelectorAll('select')
      ).filter((select) => {
        const selectName = normalize(
          select.getAttribute('name')
        );

        return (
          selectName ===
          `options[${normalizedSizeName}]`
        );
      });

      if (
        sizeRadios.length === 0 &&
        sizeSelects.length === 0
      ) {
        return;
      }

      /*
       * Remove Shopify's automatic size selection.
       */
      sizeRadios.forEach((input) => {
        input.checked = false;
        input.removeAttribute('checked');

        if (input.dataset.currentChecked) {
          input.dataset.currentChecked = 'false';
        }

        if (input.dataset.previousChecked) {
          input.dataset.previousChecked = 'false';
        }
      });

      sizeSelects.forEach((select) => {
        Array.from(select.options).forEach(
          (option) => {
            option.removeAttribute('selected');
          }
        );

        select.selectedIndex = -1;
      });

      /*
       * No actual variant must be submitted until
       * the customer selects a size.
       */
      const variantInput =
        productForm.querySelector(
          'input[ref="variantId"][name="id"]'
        ) ||
        productForm.querySelector(
          'input[name="id"]'
        );

      if (variantInput) {
        variantInput.value = '';
      }

      /*
       * Disable PDP Add to Cart.
       */
      const addToCartButton =
        guard.querySelector(
          '[ref="addToCartButton"]'
        ) ||
        productForm.querySelector(
          '[ref="addToCartButton"]'
        );

      if (addToCartButton) {
        addToCartButton.disabled = true;

        setButtonText(
          addToCartButton,
          'SELECT A SIZE'
        );

        addToCartButton.classList.add(
        'mr-select-size-button'
      );
      }

      /*
       * Hide accelerated checkout until a real
       * variant has been selected.
       */
      const acceleratedCheckout =
        productForm.querySelector(
          '[ref="acceleratedCheckoutButtonContainer"]'
        );

      if (acceleratedCheckout) {
        acceleratedCheckout.setAttribute(
          'hidden',
          'true'
        );
      }

      /*
       * Hide the preorder / estimated shipping message
       * while no size is selected.
       *
       * Its existing change listener will restore the
       * correct message after size selection.
       */
      const preorderMessages = Array.from(
        section.querySelectorAll(
          'mr-preorder-message'
        )
      );

      const preorderMessage =
        preorderMessages.find(
          (message) =>
            String(message.dataset.productId) ===
            productId
        );

      if (preorderMessage) {
        preorderMessage.hidden = true;
      }

      guard.dataset.mrSizeGuardInitialized =
        'true';
    };

    const initializeAll = (root = document) => {
      const guards = root.matches?.(
        '[data-mr-size-selection-guard]'
      )
        ? [root]
        : Array.from(
            root.querySelectorAll?.(
              '[data-mr-size-selection-guard]'
            ) || []
          );

      guards.forEach(initializeGuard);
    };

    const boot = () => {
      customElements
        .whenDefined('variant-picker')
        .then(() => {
          requestAnimationFrame(() => {
            initializeAll(document);
          });
        });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        boot,
        { once: true }
      );
    } else {
      boot();
    }

    /*
     * Theme Editor support.
     */
    document.addEventListener(
      'shopify:section:load',
      (event) => {
        requestAnimationFrame(() => {
          initializeAll(event.target);
        });
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mr-preorder-message"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mr-preorder-message')) {
    class MRPreorderMessage extends HTMLElement {
      connectedCallback() {
        this.variantDataElement = this.querySelector(
          '[data-mr-preorder-variants]'
        );

        this.labelElement = this.querySelector(
          '[data-mr-preorder-label]'
        );

        this.shippingElement = this.querySelector(
          '[data-mr-preorder-shipping]'
        );

        if (!this.variantDataElement) return;

        try {
          this.variants = JSON.parse(
            this.variantDataElement.textContent
          );
        } catch (error) {
          this.variants = [];
          return;
        }

        this.productId = String(
          this.dataset.productId
        );

        this.today = this.dataset.today;

        this.shippingPrefix =
          this.dataset.shippingPrefix ||
          'Estimated shipping in';

        this.shippingToday =
          this.dataset.shippingToday ||
          'Estimated shipping today';

        this.variantPicker =
          document.querySelector(
            `variant-picker[data-product-id="${this.productId}"]`
          );

        if (!this.variantPicker) return;

        this.handleChange =
          this.handleChange.bind(this);

        this.variantPicker.addEventListener(
          'change',
          this.handleChange
        );

        this.updateFromPicker();
      }

      disconnectedCallback() {
        if (this.variantPicker) {
          this.variantPicker.removeEventListener(
            'change',
            this.handleChange
          );
        }
      }

      handleChange() {
        requestAnimationFrame(() => {
          this.updateFromPicker();
        });
      }

      getDaysRemaining(shippingDate) {
        if (!shippingDate || !this.today) {
          return null;
        }

        const todayParts =
          this.today.split('-').map(Number);

        const shippingParts =
          shippingDate.split('-').map(Number);

        if (
          todayParts.length !== 3 ||
          shippingParts.length !== 3
        ) {
          return null;
        }

        const todayTimestamp = Date.UTC(
          todayParts[0],
          todayParts[1] - 1,
          todayParts[2]
        );

        const shippingTimestamp = Date.UTC(
          shippingParts[0],
          shippingParts[1] - 1,
          shippingParts[2]
        );

        return Math.floor(
          (shippingTimestamp - todayTimestamp) /
          86400000
        );
      }

      updateShippingText(variant) {
        if (
          !this.shippingElement ||
          !variant.shippingDate
        ) {
          return;
        }

        const daysRemaining =
          this.getDaysRemaining(
            variant.shippingDate
          );

        if (daysRemaining === null) {
          this.shippingElement.textContent = '';
          return;
        }

        if (daysRemaining > 1) {
          this.shippingElement.textContent =
            `${this.shippingPrefix} ${daysRemaining} days`;

          return;
        }

        if (daysRemaining === 1) {
          this.shippingElement.textContent =
            `${this.shippingPrefix} 1 day`;

          return;
        }

        this.shippingElement.textContent =
          this.shippingToday;
      }

      updateFromPicker() {
        if (!this.variantPicker) return;

        const selectedInput =
          this.variantPicker.querySelector(
            'input[type="radio"]:checked[data-variant-id]'
          );

        const selectedOption =
          this.variantPicker.querySelector(
            'select option:checked[data-variant-id]'
          );

        const selectedElement =
          selectedInput || selectedOption;

        if (!selectedElement) return;

        const variantId = Number(
          selectedElement.dataset.variantId
        );

        const variant = this.variants.find(
          (item) =>
            Number(item.id) === variantId
        );

        if (!variant) return;

        const shouldShow =
          variant.available === true &&
          Boolean(variant.shippingDate) &&
          (
            variant.preorder === true ||
            variant.shippingOverride === true
          );

        this.hidden = !shouldShow;

        if (!shouldShow) return;

        if (this.labelElement) {
          this.labelElement.hidden =
            variant.preorder !== true;
        }

        this.updateShippingText(variant);
      }
    }

    customElements.define(
      'mr-preorder-message',
      MRPreorderMessage
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mr-ring-couple-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mr-ring-couple-bundle')) {
    class MRRingCoupleBundle extends HTMLElement {
      connectedCallback() {
        this.finishes = [...this.querySelectorAll('[data-mr-pair-finish]')];
        this.sizes = [...this.querySelectorAll('[data-mr-pair-size]')];
        this.addButton = this.querySelector('[data-mr-pair-add]');
        this.errorBox = this.querySelector('[data-mr-pair-error]');
        try { this.primaryVariants = JSON.parse(this.querySelector('[data-mr-pair-primary-variants]')?.textContent || '[]'); }
        catch (_) { this.primaryVariants = []; }
        this.onChange = this.syncChoice.bind(this);
        this.onAdd = this.addPair.bind(this);
        this.finishes.forEach(input => input.addEventListener('change', this.onChange));
        this.sizes.forEach(select => select.addEventListener('change', this.onChange));
        this.addButton?.addEventListener('click', this.onAdd);
        this.syncChoice();
      }
      disconnectedCallback() {
        this.finishes?.forEach(input => input.removeEventListener('change', this.onChange));
        this.sizes?.forEach(select => select.removeEventListener('change', this.onChange));
        this.addButton?.removeEventListener('click', this.onAdd);
      }
      get selectedProductId() { return this.finishes.find(input => input.checked && !input.disabled)?.value || null; }
      get activeSize() { return this.sizes.find(select => select.dataset.productId === this.selectedProductId) || null; }
      syncChoice() {
        const selectedId = this.selectedProductId;
        this.sizes.forEach(select => {
          const active = select.dataset.productId === selectedId;
          select.hidden = !active;
          select.disabled = !active;
        });
        const select = this.activeSize;
        this.showError('');
      }
      showError(message) {
        if (!this.errorBox) return;
        this.errorBox.textContent = message;
        this.errorBox.hidden = !message;
      }
      findPrimaryVariant() {
        const productForm = this.closest('.product-details')?.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"] input[name="id"]`)
          || document.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"] input[name="id"]`);
        const queryVariant = new URLSearchParams(location.search).get('variant');
        const id = String(productForm?.value || queryVariant || this.dataset.primaryVariant || '');
        return this.primaryVariants.find(item => item.id === id) || null;
      }
      async addPair() {
        this.showError('');
        const primary = this.findPrimaryVariant();
        if (!primary || !primary.available) { this.showError('Choose an available size for your ring above.'); return; }
        const size = this.activeSize;
        const otherId = size?.value;
        const otherOption = size?.selectedOptions?.[0];
        if (!otherId) { this.showError('Choose a size for the second ring.'); size?.focus(); return; }
        if (otherOption?.disabled) { this.showError('That size is sold out.'); return; }
        const items = primary.id === otherId
          ? [{ id: primary.id, quantity: 2 }]
          : [{ id: primary.id, quantity: 1 }, { id: otherId, quantity: 1 }];
        const button = this.addButton;
        if (!button || button.disabled) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Unable to add the ring set to the cart.');
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.showError(error?.message || 'Something went wrong. Please try again.');
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }
    }
    customElements.define('mr-ring-couple-bundle', MRRingCoupleBundle);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mr-ring-on-hand-desktop"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mr-ring-on-hand-desktop')) {
    class MRRingOnHandDesktop extends HTMLElement {
      connectedCallback() {
        this.mediaQuery = window.matchMedia('(min-width: 750px)');
        this.syncPlayback = this.syncPlayback.bind(this);

        this.mediaQuery.addEventListener('change', this.syncPlayback);

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.syncPlayback, { once: true });
        } else {
          this.syncPlayback();
        }
      }

      disconnectedCallback() {
        this.mediaQuery?.removeEventListener('change', this.syncPlayback);
        document.removeEventListener('DOMContentLoaded', this.syncPlayback);
      }

      playSilently(video) {
        if (!video) return;
        video.muted = true;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      }

      syncPlayback() {
        const isDesktop = this.mediaQuery.matches;
        const desktopVideo = this.querySelector('video');
        const mobileVideos = document.querySelectorAll('.section-mr-ring-on-hand video');

        if (isDesktop) {
          for (const video of mobileVideos) video.pause();
          this.playSilently(desktopVideo);
        } else {
          desktopVideo?.pause();
          for (const video of mobileVideos) this.playSilently(video);
        }
      }
    }

    customElements.define('mr-ring-on-hand-desktop', MRRingOnHandDesktop);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mr-ring-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mr-ring-size-guide')) {

    class MRRingSizeGuide extends HTMLElement {

      connectedCallback() {
        this.dialog = this.querySelector(
          '.mr-ring-guide__dialog'
        );

        if (!this.dialog) return;

        this.onClick = (event) => {

          const opener = event.target.closest(
            '[data-mr-guide-open]'
          );

          if (opener) {
            const panelName = opener.dataset.mrGuideOpen;

            this.showPanel(panelName);

            if (typeof this.dialog.showModal === 'function') {
              this.dialog.showModal();
            }

            return;
          }

          const tab = event.target.closest(
            '[data-mr-guide-tab]'
          );

          if (tab) {
            this.showPanel(tab.dataset.mrGuideTab);
            return;
          }

          if (
            event.target.closest('[data-mr-guide-close]') ||
            event.target === this.dialog
          ) {
            this.dialog.close();
          }
        };

        this.onDialogClose = () => {
          this.dialog
            .querySelectorAll('video')
            .forEach((video) => video.pause());
        };

        this.addEventListener('click', this.onClick);

        this.dialog.addEventListener(
          'close',
          this.onDialogClose
        );
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);

        this.dialog?.removeEventListener(
          'close',
          this.onDialogClose
        );
      }

      showPanel(name) {
        const panel = this.querySelector(
          `[data-mr-guide-panel="${name}"]`
        );

        if (!panel) return;

        this.querySelectorAll(
          '[data-mr-guide-panel]'
        ).forEach((p) => {

          p.hidden = p !== panel;

          if (p !== panel) {
            p.querySelectorAll('video')
              .forEach((video) => video.pause());
          }

        });

        this.querySelectorAll(
          '[data-mr-guide-tab]'
        ).forEach((tab) => {

          tab.setAttribute(
            'aria-selected',
            String(tab.dataset.mrGuideTab === name)
          );

        });
      }

    }

    customElements.define(
      'mr-ring-size-guide',
      MRRingSizeGuide
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mr-see-the-fit-desktop"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mr-see-the-fit-desktop')) {
    class MRSeeTheFitDesktop extends HTMLElement {
      connectedCallback() {
        this.mediaQuery = window.matchMedia('(min-width: 750px)');
        this.syncPlayback = this.syncPlayback.bind(this);
        this.mediaQuery.addEventListener('change', this.syncPlayback);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.syncPlayback, { once: true });
        } else {
          this.syncPlayback();
        }
      }

      disconnectedCallback() {
        this.mediaQuery?.removeEventListener('change', this.syncPlayback);
        document.removeEventListener('DOMContentLoaded', this.syncPlayback);
      }

      syncPlayback() {
        const desktopVideo = this.querySelector('video');
        const originalVideos = document.querySelectorAll(
          '.shopify-section[id$="__hero_ap9mdi"] video'
        );

        if (this.mediaQuery.matches) {
          originalVideos.forEach((video) => video.pause());
          if (desktopVideo) {
            desktopVideo.muted = true;
            const playPromise = desktopVideo.play();
            playPromise?.catch?.(() => {});
          }
        } else {
          desktopVideo?.pause();
          // Mobile playback of the existing full-width Hero is managed by Horizon.
        }
      }
    }
    customElements.define('mr-see-the-fit-desktop', MRSeeTheFitDesktop);
  }
  } catch(e) { console.error(e); }
})();

})();
